// extracted by mini-css-extract-plugin
module.exports = {"cart":"CartButton_cart__LDlYB","badge":"CartButton_badge__35Eif","popup":"CartButton_popup__21YU_"};